<main class="page" role="alert">
  <h1>Ha ocurrido un error</h1>
  <p>
    No ha sido posible cargar la configuración del servicio. Inténtelo de nuevo en unos minutos o
    póngase en contacto con su servicio de atención al cliente.
  </p>
  <button type="button" (click)="reload()">Reintentar</button>
</main>
